
const dyanmicTabsApp = Vue.createApp({
    data() {
        return {
            
        }
    },
    methods: {
        showMyDiv(ElementId) {

            //Hide previous selected items
            var hideElements = document.querySelectorAll(".tab-pane.active, .nav-item.active");
            [].forEach.call(hideElements, function (el) {
                if (! el.id.includes('caro-'))
                {
                    el.classList.remove("show");
                    el.classList.remove("active");
                }
            });

            // Make navigation active
            $('#nav-' + ElementId).addClass('active');

            // Show all tabs
            var TabElements = document.querySelectorAll(".tab-pane");
            if (ElementId == "all") {
                [].forEach.call(TabElements, function (el) {
                    el.classList.add('show');
                    el.classList.add('active');
                });
            }

            //show single tab
            var panes = document.querySelectorAll('#' + ElementId);
            panes.forEach(function (pane) {
                pane.classList.add('show');
                pane.classList.add('active');
            });

            //make selected page active
            $(":disabled").each(function (index, item) {
                if (item.id.includes('Page')) {
                    $('#' + item.id).addClass('active');
                }
            });
        }
    },
    computed: {

    },

    watch: {
    },

    created() {
    },
    filters: {
    }
});

const dyanmicTabsMountedApp = dyanmicTabsApp.mount('#dynamicTabs');
